import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * Used only when {@link STRIPE_ANDROID_REQUIRE_CHROME_FOR_CHECKOUT} is true in StripeHostedCheckout.
 * Opens Stripe in Chrome Custom Tabs ({@code setPackage(com.android.chrome)})
 * or full Chrome — not the device default Custom Tabs app (e.g. Samsung Internet).
 */
const OpenInChrome = registerPlugin('OpenInChrome', {
    web: () => ({
        openUrl: async () => {
            /* Android-only */
        },
    }),
});

/**
 * @param {string} httpsUrl
 * @param {object} [browserOpenOptions]
 * @param {string} [browserOpenOptions.toolbarColor] e.g. '#1a1a1a'
 * @returns {Promise<boolean>}
 */
export async function openStripeCheckoutInChromeAndroid(httpsUrl, browserOpenOptions = {}) {
    if (Capacitor.getPlatform() !== 'android' || typeof window === 'undefined') {
        return false;
    }

    const toolbarColor = browserOpenOptions.toolbarColor;

    try {
        await OpenInChrome.openUrl({
            url: httpsUrl,
            preferChromeOnly: true,
            ...(toolbarColor != null && toolbarColor !== '' ? { toolbarColor } : {}),
        });
        return true;
    } catch (e) {
        console.warn('[Menuu] OpenInChrome failed', e);
        return false;
    }
}
